import { useCallback, useState } from 'react'

import {
  ConversationBootstrapModes,
  type ConversationBootstrap,
} from '../../hooks/useConversationStream'

export const useGlobalCommandView = () => {
  const [bootstrap, setBootstrap] =
    useState<Nullable<ConversationBootstrap>>(null)

  const startConversation = useCallback((query: string) => {
    setBootstrap({
      mode: ConversationBootstrapModes.NEW,
      initialQuery: query,
    })
  }, [])

  const resumeConversation = useCallback((conversationId: string) => {
    setBootstrap({
      mode: ConversationBootstrapModes.RESUME,
      conversationId,
    })
  }, [])

  const endConversation = useCallback(() => {
    setBootstrap(null)
  }, [])

  return {
    data: { bootstrap },
    methods: { startConversation, resumeConversation, endConversation },
  }
}
